/* Felinora — interacciones propias */
(function () {
  if (window.__flInit) return;
  window.__flInit = true;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.fl-reveal:not(.fl-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('fl-visible'); });
      return;
    }
    if (!window.__flObserver) {
      window.__flObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('fl-visible'); window.__flObserver.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { window.__flObserver.observe(el); });
  }

  function initColors(root) {
    (root || document).querySelectorAll('[data-fl-colors]').forEach(function (wrap) {
      if (wrap.__flDone) return; wrap.__flDone = true;
      var swatches = wrap.querySelectorAll('.fl-swatch');
      var imgs = wrap.querySelectorAll('.fl-colors__stage img');
      var name = wrap.querySelector('[data-fl-color-name]');
      var btn = wrap.querySelector('[data-fl-color-btn]');
      swatches.forEach(function (sw, i) {
        sw.addEventListener('click', function () {
          swatches.forEach(function (s) { s.classList.remove('is-active'); s.setAttribute('aria-pressed', 'false'); });
          imgs.forEach(function (im) { im.classList.remove('is-active'); });
          sw.classList.add('is-active'); sw.setAttribute('aria-pressed', 'true');
          if (imgs[i]) imgs[i].classList.add('is-active');
          if (name) name.textContent = sw.dataset.name;
          if (btn && sw.dataset.url) btn.setAttribute('href', sw.dataset.url);
        });
      });
      var act = wrap.querySelector('.fl-swatch.is-active');
      if (btn && act && act.dataset.url) btn.setAttribute('href', act.dataset.url);
      // Pestañas Android / iPhone: solo se ven los colores de ese sistema
      var tabs = wrap.querySelectorAll('[data-fl-os-tab]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var os = tab.dataset.flOsTab;
          tabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          var firstSw = null;
          wrap.querySelectorAll('.fl-swatches li').forEach(function (li) {
            var show = !li.dataset.os || li.dataset.os === os;
            li.hidden = !show;
            if (show && !firstSw) firstSw = li.querySelector('.fl-swatch');
          });
          if (firstSw) firstSw.click();
        });
      });
    });
  }

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    format = format || '{{amount_with_comma_separator}} €';
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, withDot);
  }

  function initProduct(root) {
    (root || document).querySelectorAll('[data-fl-product]').forEach(function (pdp) {
      if (pdp.__flDone) return; pdp.__flDone = true;
      var dataEl = pdp.querySelector('[data-fl-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var fmt = pdp.dataset.moneyFormat;
      var idInput = pdp.querySelector('input[name="id"]');
      var priceEl = pdp.querySelectorAll('[data-fl-price]');
      var compareEl = pdp.querySelector('[data-fl-compare]');
      var saleEl = pdp.querySelector('[data-fl-sale]');
      var addBtns = pdp.querySelectorAll('[data-fl-add]');
      var addLabel = pdp.dataset.addLabel, soldLabel = pdp.dataset.soldLabel;
      var mainImg = pdp.querySelector('.fl-gallery__main img');
      var thumbs = pdp.querySelectorAll('.fl-gallery__thumb');

      var counter = pdp.querySelector('.fl-gallery__count');
      var current = 0;
      thumbs.forEach(function (t, i) { if (t.classList.contains('is-active')) current = i; });
      if (counter && thumbs.length) counter.textContent = (current + 1) + ' / ' + thumbs.length;

      function showMedia(src, srcset, thumb) {
        if (!mainImg || !src) return;
        mainImg.style.opacity = '0.3';
        var tmp = new Image();
        tmp.onload = function () {
          // Quitar srcset/sizes: si no, el navegador sigue mostrando la primera foto cargada
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = src;
          if (srcset) mainImg.srcset = srcset;
          mainImg.style.opacity = '1';
        };
        tmp.src = src;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        if (thumb) {
          thumb.classList.add('is-active');
          current = Array.prototype.indexOf.call(thumbs, thumb);
          if (thumb.scrollIntoView && window.innerWidth < 750) thumb.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
        if (counter && thumbs.length) {
          var vis = visibleThumbs();
          counter.textContent = (Math.max(0, vis.indexOf(thumbs[current])) + 1) + ' / ' + vis.length;
        }
      }
      function visibleThumbs() {
        return Array.prototype.filter.call(thumbs, function (t) { return !t.parentNode.hidden; });
      }
      function go(step) {
        var vis = visibleThumbs();
        if (!vis.length) return;
        var at = vis.indexOf(thumbs[current]);
        var n = (at + step + vis.length) % vis.length;
        showMedia(vis[n].dataset.src, null, vis[n]);
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { showMedia(t.dataset.src, null, t); });
      });
      var prev = pdp.querySelector('.fl-gallery__nav--prev');
      var next = pdp.querySelector('.fl-gallery__nav--next');
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      var mainBox = pdp.querySelector('.fl-gallery__main');
      if (mainBox) {
        var x0 = null;
        mainBox.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        mainBox.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
          x0 = null;
        });
      }

      // Selector de móvil (opción "Sistema"): sin elegir, el resto de opciones queda oculto
      var osBox = pdp.querySelector('[data-fl-os-option]');
      var pickLabel = pdp.dataset.pickLabel || addLabel;
      if (osBox && !osBox.querySelector('input:checked')) {
        var want = (new URLSearchParams(window.location.search).get('sistema') || '').toLowerCase();
        var pre = want && osBox.querySelector('input[data-os="' + want + '"]');
        if (pre) pre.checked = true;
      }

      function update() {
        var selected = [];
        var pending = false;
        pdp.querySelectorAll('.fl-option').forEach(function (fs, i) {
          if (fs.hasAttribute('data-fl-os-option')) {
            var o = fs.querySelector('input:checked');
            pending = !o;
            selected.push(o ? o.value : null);
            return;
          }
          // Solo los valores que existen para lo ya elegido (p. ej. iPhone: 3 colores, sin color de rastreador)
          var allowed = {};
          variants.forEach(function (x) {
            for (var j = 0; j < i; j++) if (x.options[j] !== selected[j]) return;
            allowed[x.options[i]] = true;
          });
          var inputs = fs.querySelectorAll('input');
          var first = null, keep = false, count = 0;
          inputs.forEach(function (inp) {
            var ok = !!allowed[inp.value];
            inp.disabled = !ok;
            if (inp.nextElementSibling) inp.nextElementSibling.hidden = !ok;
            if (ok) { count++; if (!first) first = inp; if (inp.checked) keep = true; }
          });
          if (!keep && first) first.checked = true;
          fs.hidden = pending || (osBox && count <= 1);
          var c = fs.querySelector('input:checked');
          selected.push(c ? c.value : null);
          var lbl = fs.querySelector('[data-fl-selected]');
          if (lbl && c) lbl.textContent = c.value;
        });
        pdp.classList.toggle('fl-os-pending', pending);
        if (osBox) {
          var os = pending ? '' : (osBox.querySelector('input:checked').dataset.os || '');
          thumbs.forEach(function (t) { t.parentNode.hidden = !!(os && t.dataset.os && t.dataset.os !== os); });
          pdp.querySelectorAll('[data-fl-proof-os]').forEach(function (p) { p.hidden = p.dataset.flProofOs !== os; });
        }
        if (pending) {
          addBtns.forEach(function (b) {
            b.disabled = !b.closest('.fl-sticky-buy');
            (b.querySelector('span') || b).textContent = pickLabel;
          });
          return;
        }
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === selected[i]; }); });
        addBtns.forEach(function (b) {
          b.disabled = !v || !v.available;
          var span = b.querySelector('span') || b;
          span.textContent = !v ? soldLabel : (v.available ? addLabel : soldLabel);
        });
        if (!v) return;
        if (idInput) idInput.value = v.id;
        priceEl.forEach(function (p) { p.textContent = money(v.price, fmt); });
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) { compareEl.textContent = money(v.compare_at_price, fmt); compareEl.hidden = false; }
          else compareEl.hidden = true;
        }
        if (saleEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) { saleEl.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + ' %'; saleEl.hidden = false; }
          else saleEl.hidden = true;
        }
        if (v.featured_image) {
          var t = pdp.querySelector('.fl-gallery__thumb[data-media-id="' + v.featured_media_id + '"]');
          showMedia(v.featured_image, null, t);
        }
        if (window.history && window.history.replaceState && pdp.dataset.updateUrl === 'true') {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      pdp.querySelectorAll('.fl-option input').forEach(function (inp) { inp.addEventListener('change', update); });
      if (osBox) update();

      var qty = pdp.querySelector('.fl-qty input');
      // Selector de pack (1 collar / 3 collares con el 3x2)
      var packs = pdp.querySelectorAll('.fl-pack');
      function markPack(n) {
        packs.forEach(function (p) {
          var on = String(p.dataset.qty) === String(n);
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      }
      packs.forEach(function (p) {
        p.addEventListener('click', function () { if (qty) qty.value = p.dataset.qty; markPack(p.dataset.qty); });
      });
      if (qty) qty.addEventListener('input', function () { markPack(qty.value); });
      pdp.querySelectorAll('[data-fl-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(qty.value || '1', 10) + parseInt(b.dataset.flQty, 10);
          qty.value = Math.max(1, n);
          markPack(qty.value);
        });
      });

      // Añadir al carrito con el cajón de Dawn si existe; si no, envío normal del formulario
      var form = pdp.querySelector('form[action*="/cart/add"]');
      var errEl = pdp.querySelector('.fl-pdp__error');
      if (form) {
        form.addEventListener('submit', function (e) {
          var drawer = document.querySelector('cart-drawer');
          if (!window.fetch || !drawer || typeof drawer.renderContents !== 'function') return;
          e.preventDefault();
          var fd = new FormData(form);
          fd.append('sections', 'cart-drawer,cart-icon-bubble');
          fd.append('sections_url', window.location.pathname);
          addBtns.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
          fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd
          }).then(function (r) { return r.json(); }).then(function (res) {
            if (res.status) { if (errEl) errEl.textContent = res.description || res.message; return; }
            if (errEl) errEl.textContent = '';
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          }).catch(function () { form.submit(); })
            .finally(function () { addBtns.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
        });
      }

      // Barra fija de compra en móvil
      var sticky = pdp.querySelector('.fl-sticky-buy');
      var mainAdd = pdp.querySelector('.fl-add');
      if (sticky && mainAdd && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          sticky.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(mainAdd);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () {
          if (pdp.classList.contains('fl-os-pending') && osBox) {
            osBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        });
      }
    });
  }

  function initAll(root) { initReveal(root); initColors(root); initProduct(root); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
